import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatFormField, MatLabel, MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { RouteService } from "../../routing/route/route.service";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import RouteAreaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity";
import { RouteAreaService } from "../../routing/route-area/route-area.service";
import { RouteGroupService } from "../../routing/route-group/route-group.service";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { SubRouteTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/sub-route-type.enum";
import { TranslocoModule } from "@ngneat/transloco";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { SubRouteModelEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/sub-route-model.enum";
import SubRouteFunctionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route-function/sub-route-function.entity";
import { SubRouteFunctionService } from "../../routing/sub-route-function/sub-route.service";
import { ReasonVisitService } from "../../master/reason-for-visit/reason-for-visit.service";
import { ReasonVisitAttributes } from "@albatrosdeveloper/ave-models-package";
import { MatSnackBar } from "@angular/material/snack-bar";
import FrequenciesAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity";
import { SubRouteFrequenciesService } from "../../routing/sub-routes/sub-routes-frequency/sub-route-frequency.service";
import { getCode } from "app/utils/method";
import { IResult } from "app/common/interfaces";
import { TRIP_STATUS_LIST } from "app/common/enums/trip-status.enum";
@Component({
  selector: 'app-routes-filters',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormField,
    MatLabel,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    TranslocoModule
  ],
  templateUrl: './routes-filters.component.html',
  styleUrl: './routes-filters.component.scss'
})
export class RoutesFiltersComponent {

  getCode = getCode;

  constructor(
    private readonly routeService: SubRouteService,
    private readonly territoryService: RouteService,
    private readonly routeAreaService: RouteAreaService,
    private readonly routeGroupService: RouteGroupService,
    private readonly functionService: SubRouteFunctionService,
    private readonly visitService: ReasonVisitService,
    private readonly frequencyService: SubRouteFrequenciesService,
    private snackBar: MatSnackBar
  ) {
  }
  @Input() form!: FormGroup;

  @Input() territory: boolean = false;
  @Input() territoryWithMongoId: boolean = false;
  @Input() areaRoute: boolean = false;
  @Input() areaRouteWithMongoId: boolean = false;
  @Input() routeGroup: boolean = false;
  @Input() routeGroupWithMongoId: boolean = false;
  @Input() route: boolean = false;
  @Input() routeWithMongoId: boolean = false;
  @Input() type: boolean = false;
  @Input() model: boolean = false;
  @Input() modelList: any[] = [];
  @Input() function: boolean = false;
  @Input() statusTrip: boolean = false;
  @Input() reasonVisit: boolean = false;
  @Input() flagReasonVisitName: boolean = false;
  @Input() reasonVisits: string[] = []
  @Input() frecuency: boolean = false;
  @Input() frecuencyDay: boolean = false;
  @Input() routeId = null;
  @Input() loadData: boolean = undefined;

  territoryList: RouteAttributes[] = []
  filteredTerritoryList: RouteAttributes[] = [];

  routeList: RouteAttributes[] = []
  filteredRouteList: RouteAttributes[] = [];

  areaRouteList: RouteAreaAttributes[] = []
  routeGroupList: RouteGroupAttributes[] = []

  functionList: SubRouteFunctionAttributes[] = [];

  searchTerritory: string = '';
  routeSearch = '';

  typeList: any[] = []

  reasonVisitList: ReasonVisitAttributes[] = []
  filteredReasonVisitList: ReasonVisitAttributes[] = []
  searchReasonVisit: string = '';

  frecuencyList: FrequenciesAttributes[] = [];
  daysList: { code: number; day: string }[] = [
    {code: 1, day: "LU"},
    {code: 2, day: "MA"},
    {code: 3, day: "MI"},
    {code: 4, day: "JU"},
    {code: 5, day: "VI"},
    {code: 6, day: "SA"},
    {code: 7, day: "DO"}
  ];

  statusList = TRIP_STATUS_LIST;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loadData'] && changes['loadData'].currentValue === true) {
      this.loadAllData();
    }

    if (changes['reasonVisits']) {
      this.fetchReasonVisit();
    }
  }

  ngOnInit() {    
    if (this.loadData === undefined) {
      this.loadAllData();
    }

    if (this.type) {
      this.typeList = Object.entries(SubRouteTypeEnum).map(([key, value]) => ({
        key: key as SubRouteTypeEnum,
        value,
      }));
    }
    //Para modelo de ruta
    if (this.model) {
      this.modelList = Object.entries(SubRouteModelEnum).map(([key, value]) => ({
        key: key as SubRouteModelEnum,
        value,
      }));
    }
  }

  private loadAllData(): void {
    if (this.route || this.routeWithMongoId) this.fetchAllRoute();
    if (this.territory || this.territoryWithMongoId) this.fetchAllTerritory();
    if (this.areaRoute || this.areaRouteWithMongoId) this.fetchAllAreaRoute();
    if (this.routeGroup || this.routeGroupWithMongoId) this.fetchGroupRutes();
    if (this.function) this.fetchAllSubRouteFunction();
    if (this.reasonVisit) this.fetchReasonVisit();
    if (this.frecuency && this.routeId) this.getListFrecuencies();
    if (this.frecuencyDay) this.form.get("frecuencyRoute")?.setValue(this.getTodayDayCode())
  }

  private fetchAllSubRouteFunction(): void {
    this.functionService.findToComboBox().subscribe({
      next: (res) => {
        this.functionList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener funciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllRoute(): void {
    this.routeService
      .findToComboBox()
      .subscribe({
        next: (res) => {
          this.routeList = res.data;
          this.filteredRouteList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener rutas.","Cerrar",{ duration: 5000});
        },
      });
  }

  private fetchAllTerritory(): void {
    this.territoryService.findToComboBox(this.form.get("companyId")?.value).subscribe({
      next: (res) => {
        this.territoryList = res.data;
        this.filteredTerritoryList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener territorios.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllAreaRoute(): void {
    this.routeAreaService.findToComboBox(this.form.get("companyId")?.value).subscribe({
      next: (res) => {
        this.areaRouteList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener areas de rutas.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchGroupRutes(): void {
    this.routeGroupService.findToComboBox().subscribe((res) => {
      this.routeGroupList = res.data;
    });
  }

  private fetchReasonVisit(): void {
    this.visitService.findToComboBox(this.reasonVisits).subscribe((res) => {
      this.reasonVisitList = res.data;
      this.filteredReasonVisitList = res.data;
    });
  }

  filterTerritory(search: string) {
    if (!search) {
      this.filteredTerritoryList = this.territoryList;
      return;
    }
    const filterValue = search.toLowerCase();
    this.filteredTerritoryList = this.territoryList.filter(t =>
      t.name.toLowerCase().includes(filterValue) ||
      (t.externalKeys?.code?.toLowerCase().includes(filterValue))
    );
  }

  filteredRoutesList(search: string) {
    if (!search) {
      this.filteredRouteList = this.routeList;
      return;
    }
    const filterValue = search.toLowerCase();
    this.filteredRouteList = this.routeList.filter(t =>
      t.name.toLowerCase().includes(filterValue) ||
      (t.externalKeys?.code?.toLowerCase().includes(filterValue))
    );
  }

  filterReasonVisit(search: string) {
    if (!search) {
      this.filteredReasonVisitList = this.reasonVisitList;
      return;
    }
    const filterValue = search.toLowerCase();
    this.filteredReasonVisitList = this.reasonVisitList.filter(t =>
      t.name.toLowerCase().includes(filterValue));
  }

  getListFrecuencies(): void {
    this.frequencyService.findBySubRouteId(this.routeId).subscribe({
      next: (response: IResult<FrequenciesAttributes>) => {
        const filteredFrequencies = response?.data?.filter((frequency: any) => frequency.type === 'W') || [];
        this.frecuencyList = filteredFrequencies
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || 'Error al obtener las frecuencias',
          'Cerrar',
          { duration: 5000 }
        );
      },
    });
  }

  getFrecuencyDays(days: number[]): string {
    return days
      .map((dayCode) => this.daysList.find((day) => day.code === dayCode)?.day)
      .join('-');
  }

  getTodayDayCode(): number {
    const today = new Date().getDay();
    return today === 0 ? 7 : today;    // convertir 0 (Domingo) en 7
  }

  getNestedProperty(obj: any, path: string): any {
    path = path.replace(/\[(\w+)\]/g, '.$1');
    const keys = path.split('.');
    let result = obj;
    for (const key of keys) {
      if (result == null) return undefined;
      result = result[key];
    }
    return result;
  }

  getDisplayValue(
    list: any[],
    ids: any,
    field1: string,
    field2?: string
  ): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id) || ids.includes(item.id) || ids.includes(item.code))
        .map(item => {
          let result = this.getNestedProperty(item, field1) ?? '';
          if (field2) {
            const second = this.getNestedProperty(item, field2);
            if (second) {
              result += '-' + second;
            }
          }
          return result.trim();
        })
        .join(', ');
    } else {
      const found = list.find(item => item._id === ids || item.id === ids || item.code === ids);
      if (!found) return '';
      let result = this.getNestedProperty(found, field1) ?? '';
      if (field2) {
        const second = this.getNestedProperty(found, field2);
        if (second) {
          result += '-' + second;
        }
      }
      return result.trim();
    }
  }

  getDisplayValueForMongoId(
    list: ({_id: string})[],
    ids: string[],
    field1: string,
    field2?: string
  ): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id))
        .map(item => {
          let result = this.getNestedProperty(item, field1) ?? '';
          if (field2) {
            const second = this.getNestedProperty(item, field2);
            if (second) {
              result += '-' + second;
            }
          }
          return result.trim();
        })
        .join(', ');
    } else {
      const found = list.find(item => item._id === ids);
      if (!found) return '';
      let result = this.getNestedProperty(found, field1) ?? '';
      if (field2) {
        const second = this.getNestedProperty(found, field2);
        if (second) {
          result += '-' + second;
        }
      }
      return result.trim();
    }
  }

  getModelDisplay(selectedValues: string[], modelList: { key: string; value: string }[]): string {
  if (!selectedValues || !modelList) return '';
  
  return modelList
    .filter(model => selectedValues.includes(model.value))
    .map(model => model.key)
    .join(', ');
}
}
